import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY,
  ALLOCATION_DOUBLE_BOOKINGS_URL,
} from './queryConstants'

type DoubleBookingsPayload = {
  id: string
  teamMembers: string[]
  startTime?: string
  endTime?: string
}

type UseAllocationDoubleBookings = {
  doubleBookings: (values: DoubleBookingsPayload) => Promise<any>
  isDoubleBookingsLoading?: boolean
}

const useAllocationDoubleBookings = (): UseAllocationDoubleBookings => {
  const createFunction = async (values: DoubleBookingsPayload) => {
    const payload: any = {
      teamMembers: values.teamMembers,
    }

    // Include updated times if provided (e.g., when checking after a drag operation)
    if (values.startTime) {
      payload.startTime = values.startTime
    }
    if (values.endTime) {
      payload.endTime = values.endTime
    }

    return postJSON({
      url: `${ALLOCATION_DOUBLE_BOOKINGS_URL}/${values.id}`,
      method: 'POST',
      json: payload,
      isRota: true,
    })
  }

  const { mutateAsync: createMutation, isLoading: isDoubleBookingsLoading } =
    useMutation<any, unknown, any, unknown>(
      [ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY],
      createFunction
    )

  const doubleBookings = async (values: any) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    doubleBookings,
    isDoubleBookingsLoading,
  }
}

export default useAllocationDoubleBookings
